import { alpha, darken, lighten, type Theme } from '@mui/material/styles';
import type { SxProps } from '@mui/material/styles';

/**
 * Shared style for neutral dismiss actions (Close / Cancel / Back).
 * Mode-aware: solid black-on-white in light mode, solid white-on-black in
 * dark mode, so it always reads as a deliberate secondary action next to
 * the brand primary color rather than blending into either theme.
 */
export function neutralActionSx(theme: Theme) {
  const isLight = theme.palette.mode === 'light';
  const bg = isLight ? theme.palette.common.black : theme.palette.common.white;
  const color = isLight ? theme.palette.common.white : theme.palette.common.black;
  const hoverBg = isLight ? lighten(bg, 0.25) : darken(bg, 0.1);

  return {
    bgcolor: bg,
    color,
    boxShadow: 'none',
    '&:hover': {
      bgcolor: hoverBg,
      boxShadow: 'none',
    },
    '&.Mui-disabled': {
      bgcolor: alpha(bg, 0.4),
      color: alpha(color, 0.7),
    },
  } satisfies SxProps<Theme>;
}
